import React from "react";
import { useNavigate } from "react-router-dom";
import BrandLogo from "./BrandLogo";

const Navbar = () => {
  const navigate = useNavigate();
  return (
    <nav className="navbar">
      <button className="back-btn" onClick={() => navigate(-1)}>
        ← Back
      </button>
      <div className="navbar-logo">
        <BrandLogo size={64} />
      </div>
      <div style={{ width: 60 }} />
    </nav>
  );
};

export default Navbar;
